import React from 'react';
import { Instagram, ExternalLink } from 'lucide-react';

// Instagram posts data - you can update these with real post images/links
const instagramPosts = [
  {
    id: 1,
    image: 'https://customer-assets.emergentagent.com/job_smart-iron-funnel/artifacts/v4ikmef7_MDM09428.jpg',
    alt: 'Professional keratin treatment in progress with Winamor Perfect Pass iron creating bouncy curls - follow @winamor_official on Instagram'
  },
  {
    id: 2,
    image: 'https://customer-assets.emergentagent.com/job_smart-iron-funnel/artifacts/awleu9gc_DSC04270.jpg',
    alt: 'Winamor Perfect Pass LCD display showing pass count 8 for precise keratin treatment - Australia best hair iron'
  },
  {
    id: 3,
    image: 'https://customer-assets.emergentagent.com/job_smart-iron-funnel/artifacts/7xgvjhte_MDM09427.jpg',
    alt: 'Silky smooth hair straightening results with Winamor Perfect Pass keratin iron - professional salon styling'
  },
  {
    id: 4,
    image: 'https://customer-assets.emergentagent.com/job_smart-iron-funnel/artifacts/rgmn8gei_DSC04273.jpg',
    alt: 'Winamor Perfect Pass temperature control display showing 230°C - adjustable heat for all hair types'
  },
  {
    id: 5,
    image: 'https://customer-assets.emergentagent.com/job_smart-iron-funnel/artifacts/h3d7rvu8_DSC03497.jpg',
    alt: 'Winamor Perfect Pass keratin iron rose gold design on marble - premium professional hair straightener Australia'
  },
  {
    id: 6,
    image: 'https://customer-assets.emergentagent.com/job_smart-iron-funnel/artifacts/qx71rwzz_DSC03496.jpg',
    alt: 'Complete Winamor Perfect Pass keratin iron with 3m swivel cord - professional hair styling tool shop Australia'
  }
];

export const InstagramFeed = () => {
  const openInstagram = () => {
    window.open('https://www.instagram.com/winamor_official/', '_blank');
  };

  return (
    <section className="section bg-[#0a0518] relative overflow-hidden">
      <div className="container-custom relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 animate-fade-in-up">
          <span className="text-purple-400 text-sm font-semibold uppercase tracking-wider mb-4 block">
            Follow Us
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            <span className="text-gradient italic">@winamor_official</span>
          </h2>
          <p className="text-purple-200 text-lg max-w-2xl mx-auto mb-6">
            Join our community of professional hairdressers and styling enthusiasts. 
            See the Perfect Pass keratin iron in action!
          </p>
          
          <button
            onClick={openInstagram}
            data-testid="instagram-follow-btn"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-white px-6 py-3 rounded-full font-semibold hover:opacity-90 transition-opacity"
          >
            <Instagram className="w-5 h-5" />
            Follow on Instagram
            <ExternalLink className="w-4 h-4" />
          </button>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {instagramPosts.map((post, index) => (
            <a
              key={post.id}
              href="https://www.instagram.com/winamor_official/"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden rounded-xl animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img
                src={post.image}
                alt={post.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
              />
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-purple-600/0 group-hover:bg-purple-600/60 transition-colors duration-300 flex items-center justify-center">
                <Instagram className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </a>
          ))}
        </div>

        {/* Instagram Handle */}
        <div className="text-center mt-8">
          <a
            href="https://www.instagram.com/winamor_official/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-purple-400 hover:text-purple-300 transition-colors inline-flex items-center gap-2"
          >
            See more on Instagram
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
